<h3 class="ui primary header">
  {{ modal.context.title}}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <form
      class="ui form"
      [formGroup]="documentForm"
      appMargin
      style="margin-bottom: 30px"
    >
      <div style="flex-direction: column">
        <h2 class="ui head" fxFlex="auto">Document Upload</h2>
        <div class="field required" [ngClass]="displayFieldCss('documentName')">
          <label>Document Title</label>
          <input
            formControlName="documentName"
            type="text"
            placeholder="Document Title"
          />
          <app-field-error-display
            [displayError]="isFieldValid('documentName')"
            errorMsg="Please enter Document Title"
          >
          </app-field-error-display>
        </div>
        <div
          class="field required"
          [ngClass]="displayFieldCss('documentDescription')"
        >
          <label> Description</label>
          <input
            formControlName="documentDescription"
            type="text"
            placeholder="Description"
          />
          <app-field-error-display
            [displayError]="isFieldValid('documentDescription')"
            errorMsg="Please enter Description"
          >
          </app-field-error-display>
        </div>
      </div>
      <div fxLayout="row" style="margin-top: 20px">
        <h2 class="ui head" fxFlex="auto">Upload Document</h2>
      </div>
      <div class="ui divider" appMargin marginT="1"></div>
      <div class="field" appMargin marginT="5px">
        <div class="field" [ngClass]="displayFieldCss('document')">
          <div class="ui segment" style="border-radius: 8px">
            <div fxFlex="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <div fxFlex="50px">
                <div class="bordered-square"></div>
              </div>
              <div fxFlex>
                {{ fileName ? fileName : "Browse for Documents" }}
              </div>
              <div fxFlex fxLayoutAlign="end">
                <input
                  #uploadDoc
                  type="file"
                  formControlName="document"
                  accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                  #uploader
                  (change)="onFileChange($event)"
                  placeholder="Browse for documents"
                  onclick="value = null"
                  style="display: none"
                />
                <div
                  class="ui button"
                  (click)="uploader.click()"
                  style="background-color: #eaeffb; border-radius: 8px"
                >
                  Browse
                </div>
              </div>
            </div>
          </div>

          <app-field-error-display
            [displayError]="isFieldValid('document')"
            errorMsg="Please select file"
          >
          </app-field-error-display>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: inherit; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Back
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!documentForm.valid || pending"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
